export const foodData = [
  {
    id: 1,
    name: "Spring Rolls",
    price: 15.75,
    image: "https://via.placeholder.com/150",
  },
  {
    id: 2,
    name: "Chicken Satay",
    price: 15.75,
    image: "https://via.placeholder.com/150",
  },
  {
    id: 3,
    name: "Vegetable Tempura",
    price: 15.75,
    image: "https://via.placeholder.com/150",
  },
  {
    id: 4,
    name: "Edamame",
    price: 15.75,
    image: "https://via.placeholder.com/150",
  },
];

export const paymentBoxData = [
  {
    id: 1,
    title: "Total Payout",
    Value: "$15.75",
    Percentage: "2%",
  },
  {
    id: 2,
    title: "Orders",
    Value: "100",
    Percentage: "4%",
  },
  {
    id: 3,
    title: "Customers",
    Value: "120",
    Percentage: "8%",
  },
  {
    id: 4,
    title: "Customer Refunds",
    Value: "50",
    Percentage: "2%",
  },
];

export const paymentAccordianDetails = [
  {
    id: 1,
    title: "Earnings",
    value: "LKR 20,000.00",
    body: "This is the body",
  },
  {
    id: 2,
    title: "Marketing Spend",
    value: "LKR -10,000.00",
    body: "This is the body",
  },
  {
    id: 3,
    title: "Curry King Fees",
    value: "LKR 50.00",
    body: "This is the body",
  },
  {
    id: 4,
    title: "Customer Refunds",
    value: "LKR 20,000.00",
    body: "This is the body",
  },
  {
    id: 5,
    title: "Other Payments",
    value: "LKR 20,000.00",
    body: "This is the body",
  },
];

export const productData: ProductItem[] = [
  {
    id: 1,
    photo: "",
    name: "Latte",
    notes: "-",
    price: { delivery: "LKR 15.75", pickup: "LKR 15.75" },
    menu: "Lunch",
    categories: "Beverages",
    usedIn: "",
    contains: "Toppings",
    lastUpdated: "03/05",
  },

  {
    id: 2,
    photo: "",
    name: "Latte",
    notes: "-",
    price: { delivery: "LKR 15.75", pickup: "LKR 15.75" },
    menu: "Lunch",
    categories: "Beverages",
    usedIn: "",
    contains: "Toppings",
    lastUpdated: "03/05",
  },

  {
    id: 3,
    photo: "",
    name: "Latte",
    notes: "-",
    price: { delivery: "LKR 15.75", pickup: "LKR 15.75" },
    menu: "Lunch",
    categories: "Beverages",
    usedIn: "",
    contains: "Toppings",
    lastUpdated: "03/05",
  },

  {
    id: 4,
    photo: "",
    name: "Latte",
    notes: "-",
    price: { delivery: "LKR 15.75", pickup: "LKR 15.75" },
    menu: "Lunch",
    categories: "Beverages",
    usedIn: "",
    contains: "Toppings",
    lastUpdated: "03/05",
  },

  {
    id: 5,
    photo: "",
    name: "Latte",
    notes: "-",
    price: { delivery: "LKR 15.75", pickup: "LKR 15.75" },
    menu: "Lunch",
    categories: "Beverages",
    usedIn: "",
    contains: "Toppings",
    lastUpdated: "03/05",
  },

  {
    id: 6,
    photo: "",
    name: "Latte",
    notes: "-",
    price: { delivery: "LKR 15.75", pickup: "LKR 15.75" },
    menu: "Lunch",
    categories: "Beverages",
    usedIn: "",
    contains: "Toppings",
    lastUpdated: "03/05",
  },
];

export interface ProductItem {
  id: number;
  photo: string;
  name: string;
  notes: string;
  price: {
    delivery: string;
    pickup: string;
  };
  menu: string;
  categories: string;
  usedIn: string;
  contains: string;
  lastUpdated: string;
}

export const tableHeaders: TableHeader[] = [
  { header: "Photo", accessor: "photo" },
  { header: "Name", accessor: "name" },
  { header: "Notes", accessor: "notes" },
  { header: "Price", accessor: "price" },
  { header: "Menu", accessor: "menu" },
  { header: "Categories", accessor: "categories" },
  { header: "Used In", accessor: "usedIn" },
  { header: "Contains", accessor: "contains" },
  { header: "Last Updated", accessor: "lastUpdated" },
];

export interface TableHeader {
  header: string;
  accessor: string;
}

export const NAV_LIST = [
  {
    id: 1,
    item: "Payouts",
  },
  {
    id: 2,
    item: "Banking",
  },
  {
    id: 3,
    item: "Invoices",
  },
  {
    id: 4,
    item: "Invoice Settings",
  },
];

export const NAV_LIST_SUBSCRIPTION = [
  {
    id: 1,
    item: "Overview",
  },
  {
    id: 2,
    item: "Menu",
  },
  {
    id: 3,
    item: "Categories",
  },
  {
    id: 4,
    item: "Items",
  },
  //   {
  //     id:5,
  //     item: "Modifier Groups"
  // }
];

export const NAV_LIST_REGULAR_OVERVIEW_EDIT_COMPONENT = [
  {
    id: 1,
    item: "Basic",
  },
  {
    id: 2,
    item: "Details",
  },
];

export const NAV_LIST_CART_CONTROLLER = [
  {
    id: 1,
    item: "Overview",
  },
  {
    id: 2,
    item: "Inventory",
  },
  {
    id: 3,
    item: "Sales",
  },
  {
    id: 4,
    item: "Live Location"
  },
  {
    id: 5,
    item:"Delivery Session"
  }
];

export const NAV_LIST_CART_CONTROLLER_INVENTORY_VIEW = [
  {
    id: 1,
    item: "Item List",
  },
];

export const NAV_LIST_MENU_ITEM = [
  {
    id: 1,
    item: "All SKUs'",
  },
  {
    id: 2,
    item: "Sellable Products",
  },
  {
    id: 3,
    item: "Customizable SKU",
  },
  {    id: 4,
    item: "Archived SKUs",
  },
];

export const NAV_LIST_PRODUCTS = [
  {
    id: 1,
    item: "Products",
  },
  {
    id: 2,
    item: "Combo Menu",
  },
  {
    id: 3,
    item: "Customize Menu",
  },
];
